export let useNepali= true;
let usedText;

let NepaliText = {
    //List Page

    active:'भइरहेछ',
    closed:'सक्कियो',
    voteNow:'भोट गर्नुहोस्',
    messages:'सन्देशहरु',
    msgText:'तपाईंले यहाँ हाम्रो सन्देश प्राप्त गर्नुहुनेछ',
    viewResult : 'नतिजा हेर्नुहोस्',
    viewDetails :'विस्तृतमा हेर्नुहोस्',
    loadMore :'थप हेर्नुहोस्',

    //Detail Page
    taliWaGali: 'ताली वा गाली',
    playing: 'खेलिरहेको',
    played: 'खेलिसकेको',
    voted:'भोटहरु',
    shareIt: 'सेयर गर्नुहोस्',
    viewAll: 'सबै हेर्नुहोस्',
    shareIssue: 'यो विषयवस्तु सेयर गर्नुहोस्',
    contactUs: 'सम्पर्क गर्नुहोस्',
    votingEnded: 'भोटिङ सक्कियो',
    submit:'भोट गर्नुहोस्',
    termsService:'नियम तथा शर्तहरु',
    submitting:'भोट दर्ता हुँदैछ',
    enabling2x:'2X भोट सुचारु गरिंदै',
    winners:'विजेताहरु',
    sponsor:'प्रायोजक',
    sponsoredBy : 'प्रायोजन',
    days:'दिन',
    hour:'घण्टा',
    minute:'मिनेट',
    second:'सेकेण्ड',
    thankYou: 'धन्यवाद!',

    voteShareMSG : 'आफ्ना साथीभाई, परिवाजनलाई यो विषयवस्तुमा भोटिङका लागि प्रोत्साहित गर्न सेयर गर्नुहोस्',

    thankYouMsg: 'तपाईंको अमूल्य भोटका लागि धन्यवाद !  अन्य भोटिङहरुमा पनि भाग लिनुहोला । किनकी तपाईंको भोट परिवर्तनका लागि महत्व राख्दछ ।',
    greetingThanks: 'शुभकामना तथा आभार!',
    congratulation: 'बधाई छ!',

    winningMsg: 'तपाईंले निम्न पुरस्कार प्राप्त हुनुभएको छ',
    yay :'आहा!',
    enabledMsg2x: 'यस विषयवस्तुसँग सम्बन्धित भोटिङ सेयर (2X) गरि अरुलाई पनि प्रात्साहित गर्नुभएकोमा धन्यवाद!',

    greatJob: 'गज्जब!',
    before2x: 'तपाईंको अमूल्य भोटका लागि धन्यवाद ! कृपया अरुलाई पनि प्रोत्साहन गर्नका लागि यस विषयवस्तुलाई सेयर (2X) गर्नुहोस् ।',
    shareBoxMsg :'तपाईंको भोट अमूल्य छ ! \n' + 'तर साझा अभिमतका लागि साथीभाई तथा परिवारजनको धारणा पनि आवश्यक छ । कृपया! यो भोटिङमा वहाँहरुको सहभागिताका लागि सेयर गर्नुहोस् ',

    waitingResultMsg : 'कृपया भोटिङ नतिजा सार्वजनिक नहुञ्जेल प्रतिक्षा गर्नुहोस्',

    //winners Page
    congratulationMSG:'सम्पूर्ण बिजेताहरुलाई बधाई छ!',
    additionalText:'तपाईं पनि नियमित संचालन भईरहने विभिन्न विषयवस्तु केन्द्रित भोटिङहरुमा सहभागी हुनसक्नुहुनेछ',
    details:'विस्तृत जानकारी यहाँ देखिनेछ',

    //chatPage
    msgClosed: 'सन्देश बन्द',

//    others
    notFound: 'भेटिएन',
    ok :'हुन्छ',
    logout:'लग आउट',

    //login Page
    loginText:'हाम्रो कम्यूनिटीमा तपाईंलाई स्वागत छ! तपाईंले लगइन गरेर हाम्रो भोटिङमा सहभागी हुन सक्नुहुनेछ ।',
    pleaseWait:'कृपया ! प्रतिक्षा गर्नुहोस्',
    tryAgain:'पुनः प्रयास गर्नुहोस्',
    somethingWentWrong:'केही समस्या देखियो',
    votes:'भोट',
    information:'जानकारी',
    withoutLoginMSG:'तपाईं अहिले लगइन हुनुहुन्न । भोट गर्न लगइन गर्नुहोस् ।',
    loginNow:'लगइन गर्नुहोस्',
    selectOne:'कृपया एउटा विकल्प रोज्नुहोस्',
    votedLoginText: 'तपाईको भोट दर्ता भयो । कृपया लगइन गरि आफ्नो भोट सुरक्षित गर्नुहोस् |'
};

let EnglishText = {
    //List Page

    active:'Active',
    closed:'Closed',
    voteNow:'VOTE NOW',
    messages:'Messages',
    msgText:'You will get our message here.',
    viewResult : 'VIEW RESULT',
    viewDetails :'VIEW DETAILS',
    loadMore :'LOAD MORE',

    //Detail Page
    taliWaGali: 'Tali wa Gali',
    playing: 'PLAYING',
    played: 'PLAYED',
    voted:'VOTED',
    shareIt: 'SHARE IT',
    viewAll: 'VIEW All',
    shareIssue: 'SHARE THIS ISSUE',
    contactUs: 'CONTACT US',
    votingEnded: 'Voting Ended',
    submit:'SUBMIT',
    termsService:'Terms & Conditions',
    submitting:'SUBMITTING VOTE',
    enabling2x:'ENABLING 2X VOTING',
    winners:'WINNERS',
    sponsor:'Sponsor',
    sponsoredBy : 'Sponsored by',
    days:'days',
    hour:'hour',
    minute:'minute',
    second:'second',
    thankYou: 'THANK YOU',

    voteShareMSG : 'Share this issue to encourage your friends to vote.',

    thankYouMsg: 'Thank you for your vote, Keep Voting. Your Vote matters.',
    greetingThanks: 'Greeting and thanks',
    congratulation: 'CONGRATULATIONS',

    winningMsg: 'You have won following prize.',
    yay :'YAY',
    enabledMsg2x: 'Thank you for sharing this issue to inspire others. (2X)',

    greatJob: 'Great Job',
    before2x: 'Thank you for your vote! Please Share this issue to inspire others.',
    shareBoxMsg :'Your Vote is valuable! \n' + 'but it is important that your friends and family also participate in this voting, Please share this to inspire them.',

    waitingResultMsg : 'Please wait until the voting result is announced.',

    //winners Page
    congratulationMSG:'Congratulations to all the Winners!',
    additionalText:'You can also participate in regular quiz games and get a chance to win the prizes.',
    details:'Details will be feature here.',

    //chatPage
    msgClosed: 'Message Closed',

//    others
    notFound: 'Not Found',
    ok :'OK',
    logout:'Logout',

    //login Page
    loginText:'Welcome to Hamro Patro Tali wa Gali. With your personal account, you can now participate in voting.',
    pleaseWait:'Please Wait',
    tryAgain:'Try Again',
    somethingWentWrong:'Something went wrong',
    votes:'votes',
    information:'Information',
    withoutLoginMSG:'You are not logged in. Please Login to vote.',
    loginNow:'Login Now',
    selectOne:'Please select one option',
    votedLoginText: 'Your vote is now counted. Please login to register your vote in your name.'
};

if(useNepali){
    usedText= NepaliText;
}else
    usedText=EnglishText;

export default usedText;